export default __webpack_public_path__ + "static/media/script-full-macos.19d37e2c.avif";